import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatToolbarModule } from '@angular/material/toolbar';
import { Route, RouterModule } from '@angular/router';
import { NgbPopoverModule, NgbTimepickerModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { TimePickerModule } from 'src/app/components/time-picker/time-picker.module';
import { NewTaskComponent } from '../../components/new-task/new-task.component';
import { CvvCommonModule } from '../cvv-common/cvv-common.module';
import { SharedModule } from '../shared-module/shared.module';


const routes: Route[] = [{
  path: 'newTask',
  component: NewTaskComponent,
  children: [
    {path: 'create', component: NewTaskComponent, outlet: 'side'}
  ]
}];

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    MatToolbarModule,
    MatIconModule,
    MatButtonModule,
    MatSelectModule,
    MatFormFieldModule,
    MatInputModule,
    NgxMaterialTimepickerModule,
    FormsModule,
    ReactiveFormsModule,
    NgbPopoverModule,
    NgbTimepickerModule,
    SharedModule,
    CvvCommonModule,
    TimePickerModule
  ],
  declarations: [NewTaskComponent],
  exports:[NewTaskComponent]
})
export class NewTaskModule { }
